import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const managePaymentsApi = createApi({
    reducerPath: "managePaymentsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAllSales: builder.query({
            query: () => ({
                url: "/Sale/all-sales",
                method: "GET",
            }),
        }),
        getTodaySales: builder.query({
            query: () => ({
                url: "/Sale/all-sales-today",
                method: "GET",
            }),
        }),
        getRefundedSales: builder.query({
            query: () => ({
                url: "/Sale/all-refunded-sales",
                method: "GET",
            }),
        }),
    }),
});

export const { useGetAllSalesQuery, useGetTodaySalesQuery, useGetRefundedSalesQuery } = managePaymentsApi;
